import PropTypes from 'prop-types';
import React from 'react';
import UserForm from '../Shared/userForm';
import SimpleHeader from '../../../../main/headers/simpleHeader';

const AddUser = ({ shops, tmpPassword, saveNewUser, initialValues }) => (
  <div>
    <SimpleHeader heading="Add user" />
    <div className="c-wrapper">
      <div className="o-flexbox">
        <div className="o-flexbox__item o-flexbox__item--flex-start u-1/1">
          <div className="c-inner-wrapper u-max-width-710 u-mb-" display-if={!!tmpPassword}>
            Temporary password for this user is{' '}
            <strong data-automation-id="password">{tmpPassword}</strong>
          </div>
          <UserForm
            initialValues={initialValues}
            saveUpdatedUser={saveNewUser}
            shops={shops}
          />
        </div>
      </div>
    </div>
  </div>
);

AddUser.propTypes = {
  saveNewUser: PropTypes.func.isRequired,
  tmpPassword: PropTypes.string,
  shops: PropTypes.array.isRequired,
  initialValues: PropTypes.object.isRequired,
};

AddUser.defaultProps = {
  tmpPassword: '',
};

export default AddUser;
